import { BgRndVideo } from '../BgRndVideo/BgRndVideo';
import { MessagesList } from '../MessagesList/MessagesList';
import { Prize } from '../Prize/Prize';

import styles from './Rnd.module.css';

export const Rnd = ({
  voteState,
  winnerMessage,
  showedMessages,
  speed,
  isStateWin,
}) => {
  return (
    <div className={styles.rndWrapper}>
      <MessagesList
        winId={winnerMessage?.message.id}
        messages={showedMessages}
        speed={speed || 0}
        isStateWin={isStateWin}
      />

      <Prize voteState={voteState} />

      <BgRndVideo />
    </div>
  );
};
